// re-written in node for gatsby-node interoperability

module.exports = (input) => (
  input.replace(/^\/|\/$/g, '')
);
